<template>
  <header class="subtle flex align-items-center fixed c1">
    <div class="logo inline-block mr2"><router-link
      :to="{ name: 'dashboard'}"
      active-class="active"
      class="block">
      <lw-image
        v-if="organization.logo"
        :src="organization.logo"
        :alt="organization.name"
        :class="'org-logo'"/>
      <template v-else>{{ organization.name }}</template>
    </router-link></div>
    <nav
      v-if="user"
      id="primary-nav"
      class="primary justify-self-center subtle">
      <div class="links">
        <router-link
          :to="{ name: 'estimates'}"
          active-class="active"
          @click.native="isOpen = false"><svg-estimate/> Estimates</router-link>
        <router-link
          :to="{ name: 'redflags'}"
          active-class="active"
          @click.native="isOpen = false"><svg-red-flag/> Red flags</router-link>
        <router-link
          :to="{ name: 'rates'}"
          active-class="active"
          @click.native="isOpen = false"><svg-rate-card/> Rate cards</router-link>
      </div>
    </nav>
    <div
      :class="saved ? 'grey-text' : 'dark-red-text'"
      class="align-self-center font-size-2 semibold align-right mlAuto saved">{{ saved ? 'Saved' : 'Saving' }}</div>
    <appSettings/>
  </header>
</template>

<script>
import { mapGetters } from 'vuex'
import Logo from '../svgs/Logo'
import Estimate from '../svgs/Estimate'
import RedFlag from '../svgs/RedFlag'
import RateCard from '../svgs/RateCard'
import Settings from './Settings'
import Image from '../livewires/Image'

export default {
  components: {
    svgLogo: Logo,
    svgEstimate: Estimate,
    svgRedFlag: RedFlag,
    svgRateCard: RateCard,
    appSettings: Settings,
    lwImage: Image
  },
  computed: {
    ...mapGetters([
      'user',
      'organization',
      'userLoading',
      'saved'
    ])
  }
}
</script>

<style scoped>
  header {
    z-index: 900;
    top: 0;
  }
  .logo {
    max-width: calc(100% - (var(--line) * 3));
  }
  .logo a {
    font-size: var(--font-size-3);
    line-height: var(--line-height-3);
    padding: calc(var(--line) * 0.9) 0 calc(var(--line) * 0.7) var(--page-margin);
    text-decoration: none;
    letter-spacing: 0.033em;
    font-weight: var(--bold);
    font-family: var(--display);
  }
  .primary {
    position: fixed;
    bottom: 0;
    left:0;
    width: 100%;
    z-index: 10;
    padding-bottom: env(safe-area-inset-bottom);
  }
  .links {
    width: 100%;
    display: flex;
    justify-content: space-around;
  }
  .primary a {
    font-size: var(--font-size-1);
    line-height: var(--line-height-1);
    text-decoration: none;
    outline:0;
    font-weight: var(--medium);
    display: inline-block;
    padding: calc(var(--line) * 0.66) calc(var(--line) * 0.25);
    font-family: var(--sans);
    letter-spacing: 0;
    text-align: center;
  }
  @supports(padding: max(0px)) {
    .logo a {
      padding-left: max(var(--page-margin), env(safe-area-inset-left));
    }
  }
  .primary svg {
    fill: var(--dark-grey);
    width: 1em;
    height: 1em;
    display: block;
    margin: 0.1em auto;
  }
  .logo a:hover,
  .logo a:active,
  .logo a:focus,
  .primary a:hover,
  .primary a:active,
  .primary a:focus {
    color: var(--accent);
  }
  .primary a.active {
    color: var(--accent);
    cursor: default;
  }
  .primary a.active svg {
    fill: var(--accent);
  }
  .saved {
    position: absolute;
    top: calc(var(--line) * 3);
    right: var(--page-margin);
  }
  @media screen and (max-width: 48em) {
    .settings-open .saved {
      opacity: 0;
    }
  }
  @media screen and (min-width: 48em) {
    .logo a {
      font-size: var(--font-size-4);
      line-height: var(--line-height-1);
      padding-right: var(--line);
      letter-spacing: 0;
      align-items: baseline;
    }
    .primary {
      position: relative;
      padding-top: 0.25em;
      align-items: baseline;
      z-index: auto;
      width: auto;
      padding-bottom: 0;
    }
    .links {
      display: block;
      width: auto;
    }
    .primary  a {
      font-size: var(--font-size-3);
      line-height: var(--line-height-3);
      padding: var(--line) calc(var(--line) * 0.5);
      display: inline-block;
      font-family: var(--display);
      font-weight: var(--bold);
      border: none;
      margin-left: calc(var(--line) * 0.25);
      margin-right: calc(var(--line) * 0.25);
      text-align: left;
    }
    .primary svg {
      width: 0.9em;
      height: 0.9em;
      vertical-align: top;
      margin-top: 0.2em;
      margin-right: 0.1em;
      display: inline-block;
    }
    .saved {
      top: calc(var(--line) * 4.25);
    }
  }
</style>
